module.exports = __webpack_public_path__ + "static/img/背景板.a1021460.png";